export const isValidProductId = (productId) => /^prod\d+$/.test(productId);
